import { Navigate, useLocation } from 'react-router-dom';

type LegacyPathRedirectProps = {
  from: RegExp;
  to: string;
};

/** @returns `null` when the pattern does not change the path (avoids redirect loops). */
export function normalizeRedirectPath(pathname: string, from: RegExp, to: string): string | null {
  const nextPath = pathname.replace(from, to);
  if (nextPath === pathname) {
    return null;
  }
  const base = nextPath || '/';
  const withSlash = base.startsWith('/') ? base : `/${base}`;
  return withSlash;
}

/** Compatibility redirects for transient rebranding URLs that are no longer canonical. */
export const LegacyPathRedirect = ({ from, to }: LegacyPathRedirectProps) => {
  const { pathname, search, hash } = useLocation();
  const nextPath = normalizeRedirectPath(pathname, from, to);
  if (nextPath === null) {
    return null;
  }

  return <Navigate to={`${nextPath}${search}${hash}`} replace />;
};
